import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { SiteDataProvider } from "./context/SiteDataContext";
import HomePage from "./pages/HomePage";
import ReprogrammationPage from "./pages/ReprogrammationPage";
import FilmsSolairesPage from "./pages/FilmsSolairesPage";
import ContactPage from "./pages/ContactPage";
import CGVPage from "./pages/CGVPage";
import AdminPage from "./pages/AdminPage";

function App() {
  return (
    <HelmetProvider>
      <SiteDataProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/reprogrammation" element={<ReprogrammationPage />} />
              <Route path="/films-solaires" element={<FilmsSolairesPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/cgv" element={<CGVPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </BrowserRouter>
        </div>
      </SiteDataProvider>
    </HelmetProvider>
  );
}

export default App;
